import "core-js/modules/es.array.push.js";
import $ from 'jquery';
import Bus from '@/assets/js/bus.js';
import Tools from '@/assets/js/utils.js';
let AgoraRTMClient = null;
export default {
  props: {
    nickNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tagNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    organizationInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    allPartyMembers: {
      type: Array,
      default: function () {
        return [];
      }
    },
    chatPartyCode: {
      default: ''
    },
    showComponent: {
      default: ''
    }
  },
  data() {
    return {
      lockPublic: true,
      lockPrivate: true,
      rtm: null,
      rtmStatus: '',
      imageUrl: '',
      chatList: [],
      activeChat: {},
      lastActiveRtilCode: '',
      message: '',
      memberBtn: false,
      searchMember: '',
      token: '',
      messageInfo: {},
      isReadInfo: {},
      scroll: {
        onScroll: this.scollMessage,
        scrollDirection: 'top'
      },
      loadingMessage: {},
      channelParams: {},
      messageDivHeight: '',
      chatToken: '',
      httpsToken: '',
      noMore: false,
      pageSize: 20,
      historyParams: {},
      recordOffsetKey: {},
      filterHide: {},
      allChatList: [],
      AgoraRTMClient: null
    };
  },
  computed: {
    disabledChat() {
      let flag = false;
      if (this.userInfo.managerRtils.includes(this.userInfo.rtilCode)) {
        return false;
      }
      if (this.activeChat.rtilCode == this.chatPartyCode && this.lockPublic) {
        flag = true;
      }
      if (this.activeChat.rtilCode != this.chatPartyCode && this.lockPrivate && !this.userInfo.managerRtils.includes(JSON.parse(this.activeChat.rtilCode))) {
        flag = true;
      }
      return flag;
    }
  },
  watch: {
    isReadInfo: {
      deep: true,
      handler: function (val) {
        this.$emit('callback', {
          type: 'unreadInfo',
          data: val
        });
      }
    },
    showComponent: function (val, old) {
      if (val) {
        this.$set(this.isReadInfo, this.activeChat.rtilCode, {
          ...this.isReadInfo[this.activeChat.rtilCode],
          unRead: false
        });
        // 更新group的未读消息时间
        this.recordChatTime();
        // 聊天消息 滚到底部
        this.$nextTick(() => {
          if (!this.$refs.chat) return;
          const height = this.$refs.chat.scrollHeight;
          $('.chatMessage').animate({
            scrollTop: height
          }, 0);
        });
      } else {
        this.lastActiveRtilCode = '';
      }
    },
    allPartyMembers: {
      handler: function (list) {
        this.allChatList = [];
        this.addHostChatList(list);
        list.forEach(v => {
          if (v && !this.allChatList.includes(parseInt(v))) {
            this.allChatList.push(parseInt(v));
          }
        });
      },
      immediate: true
    },
    // 自谷歌浏览器 108 版本开始同时 important 会导致媒体设备允许弹框不出来
    // 改为延时加载
    'userInfo.rtilCode': {
      immediate: true,
      handler: async function (val) {
        if (val) {
          AgoraRTMClient = require('@/assets/js/rtm-client').default;
          if (this.rtm) return;
          await this.getChatToken();
          const params = {
            appId: this.userInfo.appId,
            uid: this.userInfo.rtilCode,
            channel: this.chatPartyCode,
            token: this.chatToken // 暂时为空
          };

          this.rtm = new AgoraRTMClient(this.callBack);
          this.rtm.join(params).then(() => {
            this.rtm.joinChannel({
              id: this.chatPartyCode
            }).then(res => {
              this.rtm.channels[this.chatPartyCode].joined = true;
            });
          });
        }
      }
    }
  },
  async created() {
    Bus.$off('setPrivateTextChat');
    Bus.$on('setPrivateTextChat', () => {
      this.lockPrivate = false;
    });
    Bus.$off('cancelPrivateTextChat');
    Bus.$on('cancelPrivateTextChat', () => {
      this.lockPrivate = true;
    });
    Bus.$off('setPublicTextChat');
    Bus.$on('setPublicTextChat', () => {
      this.lockPublic = false;
    });
    Bus.$off('cancelPublicTextChat');
    Bus.$on('cancelPublicTextChat', () => {
      this.lockPublic = true;
    });
    // 初始化选中group
    this.activeChat = {
      nickName: 'Group chat ',
      rtilCode: this.chatPartyCode
    };
    this.$set(this.nickNameInfo, this.chatPartyCode, 'Group chat ');
    this.getChatList({
      partyCode: this.userInfo.chatCode,
      rtilCode: this.userInfo.rtilCode
    });

    // gallery查询多party下所有人员
    this.$emit('callback', {
      type: 'getAllMembers'
    });

    // 获取lock状态
    this.lockPublic = !this.userInfo.status.publicTextChat;
    this.lockPrivate = !this.userInfo.status.privateTextChat;

    // 获取chat token，并加入trm
    this.$set(this.loadingMessage, this.chatPartyCode, true);
    this.historyParams = {
      partyCode: this.userInfo.chatCode,
      type: 2,
      source: '',
      destination: '',
      pageNum: 1,
      pageSize: 20
    };

    // 获取group历史记录
    this.getChannelHistoryList(this.historyParams);
  },
  mounted() {
    this.getChannelUnRead();
    document.addEventListener('mouseup', this.hideLinkOperate, false);
  },
  methods: {
    addHostChatList(list) {
      // 与会者被lock住，需要自动添加host到chatList
      if (this.userInfo.managerRtils.includes(this.userInfo.rtilCode)) return;
      list.forEach(v => {
        if (this.userInfo.managerRtils.includes(parseInt(v))) {
          let btn = false;
          this.chatList.forEach(val => {
            if (val.rtilCode == v) {
              btn = true;
            }
          });
          if (!btn) {
            this.chatList.unshift({
              rtilCode: v
            });
          }
        }
      });
    },
    changeLock(type) {
      const params = {
        partyCode: this.userInfo.joinCode,
        module: '',
        msg: {}
      };
      const request = {
        public: {
          params: {
            ...params,
            module: this.lockPublic ? 'cancelPublicTextChat' : 'setPublicTextChat'
          }
        },
        private: {
          params: {
            ...params,
            module: this.lockPrivate ? 'cancelPrivateTextChat' : 'setPrivateTextChat'
          }
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=70947', request[type].params);
    },
    async getChatToken() {
      await this.axios.post('/partyline-backend/chat/noLogin/getChatToken', {
        partyCode: this.chatPartyCode,
        rtilCode: this.userInfo.rtilCode
      }).then(res => {
        this.chatToken = res.data.result;
      });
    },
    async getHttpsToken() {
      await this.axios.post('/partyline-backend/chat/noLogin/getApiToken', {
        partyCode: this.chatPartyCode
      }).then(res => {
        this.httpsToken = res.data.result;
      }).catch(() => {
        this.$set(this.loadingMessage, params.filter.destination, false);
      });
    },
    // 获取channel相关
    getChannelUnRead() {
      // 未读消息
      this.axios.post('/partyline-backend/chat/noLogin/isChannelUnRead', {
        partyCode: this.userInfo.chatCode,
        rtilCode: this.userInfo.rtilCode
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          this.$set(this.isReadInfo, this.chatPartyCode, {
            unRead: res.data.result.existUnRead,
            time: res.data.result.lastReadTime
          });
        }
      });
    },
    async getChannelHistoryList(params, str) {
      // 历史记录
      this.getHistoryMessage(params, str);
    },
    // peerTopeer相关
    getChatList(params) {
      // 私聊列表
      this.axios.post('/partyline-backend/chat/noLogin/listChatRecord', params).then(res => {
        if (res.data.errorCode == '0x0') {
          const list = res.data.result.list || [];
          list.forEach((v, k) => {
            if (this.userInfo.managerRtils.includes(this.userInfo.rtilCode)) {
              // 与会者被lock住，需要自动添加host到chatList
              if (this.allChatList.includes(v.rtilCode) && this.userInfo.managerRtils.includes(parseInt(v.rtilCode))) {
                list.splice(k, 1);
                return;
              }
            }
            if (!this.allChatList.includes(v.rtilCode)) {
              // 不在线的rtilCode，需要重新查询信息
              this.$emit('callback', {
                type: 'nickName',
                rtilCode: v.rtilCode
              });
            }
            this.$set(this.isReadInfo, v.rtilCode, {
              unRead: v.existUnRead,
              time: v.lastReadTime
            });
          });
          this.chatList = this.chatList.concat(list);
        }
      });
    },
    getHistoryMessage(params, str) {
      // 历史记录
      this.$set(this.loadingMessage, this.activeChat.rtilCode, true);
      // 私聊查询
      params.lastTime = this.recordOffsetKey[this.activeChat.rtilCode];
      this.axios.post('/partyline-backend/chat/noLogin/listChatHistory', params).then(res => {
        this.$set(this.loadingMessage, this.activeChat.rtilCode, false);
        if (res.data.errorCode == '0x0') {
          const message = res.data.result.list || [];
          if (message.length) {
            this.recordOffsetKey[this.activeChat.rtilCode] = message[message.length - 1].timestamp;
          }
          this.fotmatMsgData(message, this.activeChat.rtilCode, str);
        }
      }).catch(() => {
        this.$set(this.loadingMessage, this.activeChat.rtilCode, false);
      });
    },
    fotmatMsgData(message, id, str) {
      message = message.sort(this.compare('timestamp'));
      if (this.chatPartyCode == this.activeChat.rtilCode) {
        const ids = [...new Set(message.map(v => v.source))];
        ids.forEach(v => {
          // 获取名字
          if (!this.nickNameInfo[v]) {
            // 没有nickName，需要重新查询信息，顺便查出tagName，tagName只有人在线时才可以修改
            this.$emit('callback', {
              type: 'nickName',
              rtilCode: v
            });
          }
        });
      }
      if (message.length < 20) {
        this.noMore = true;
      }
      let data = message;
      if (str == 'srcoll') {
        data = data.concat(this.messageInfo[id] || []);
      }
      this.$set(this.messageInfo, id, data);
      this.dateSplitChatRecord(this.messageInfo[this.activeChat.rtilCode]);
      this.$nextTick(() => {
        if (!this.$refs.chat) return;
        if (str == 'srcoll') {
          $('.chatMessage').animate({
            scrollTop: this.$refs.chat.scrollHeight - this.messageDivHeight
          }, 0);
          this.messageDivHeight = this.$refs.chat.scrollHeight;
        } else {
          this.messageDivHeight = this.$refs.chat.scrollHeight;
          $('.chatMessage').animate({
            scrollTop: this.messageDivHeight
          }, 0);
        }
      });
    },
    // 滚动加载
    async scollMessage() {
      if (this.loadingMessage[this.activeChat.rtilCode] || !this.messageInfo[this.activeChat.rtilCode] || this.noMore) return;
      if (this.activeChat.rtilCode == this.chatPartyCode) {
        this.historyParams.type = 2;
        this.historyParams.source = '';
        this.historyParams.destination = '';
        this.getChannelHistoryList(this.historyParams, 'srcoll');
      } else {
        this.historyParams.type = 1;
        this.historyParams.source = this.userInfo.rtilCode;
        this.historyParams.destination = this.activeChat.rtilCode;
        this.getHistoryMessage(this.historyParams, 'srcoll');
      }
    },
    search() {
      this.allChatList.forEach(v => {
        if (!this.searchMember) {
          this.$set(this.filterHide, v, false);
        } else {
          if (this.nickNameInfo[v].indexOf(this.searchMember) >= 0) {
            this.$set(this.filterHide, v, false);
          } else {
            this.$set(this.filterHide, v, true);
          }
        }
      });
    },
    changeChat(item) {
      this.memberBtn = false;
      this.noMore = false;
      this.lastActiveRtilCode = this.activeChat.rtilCode;
      if (!item) {
        this.activeChat = {
          nickName: 'Group chat ',
          rtilCode: this.chatPartyCode
        };
      } else {
        this.activeChat = item;
        if (!this.messageInfo[this.activeChat.rtilCode]) {
          this.historyParams.type = 1;
          this.historyParams.source = this.userInfo.rtilCode;
          this.historyParams.destination = item.rtilCode;
          this.historyParams.pageNum = 1;
          this.getHistoryMessage(this.historyParams);
        }
      }
      if (this.messageInfo[this.activeChat.rtilCode]) {
        // 聊天消息 滚到底部
        this.$nextTick(() => {
          if (!this.$refs.chat) return;
          const height = this.$refs.chat.scrollHeight;
          $('.chatMessage').animate({
            scrollTop: height
          }, 0);
        });
      }
      this.$set(this.isReadInfo, this.activeChat.rtilCode, {
        ...this.isReadInfo[this.activeChat.rtilCode],
        unRead: false
      });
      this.recordChatTime();
    },
    changeMember() {
      this.memberBtn = true;
      this.activeChat = {};
      // gallery查询多party下所有人员
      this.$emit('callback', {
        type: 'getAllMembers'
      });
    },
    selectMember(rtilCode) {
      const obj = {
        rtilCode
      };
      this.chatList.forEach((v, index) => {
        if (v.rtilCode == rtilCode) this.chatList.splice(index, 1);
      });
      this.chatList.unshift(obj);
      this.changeChat(obj);
    },
    sendMessage() {
      if (!this.message.replace(/\s*/g, '') || !this.message.replace(/\n/g, '')) {
        return;
      }
      if (this.rtmStatus != 'CONNECTED') {
        this.$notify({
          title: 'Tips',
          type: 'warning',
          message: 'Service connecting, please wait'
        });
        this.$message({
          message: this.rtmStatus,
          type: 'warning'
        });
        return;
      }
      if (this.activeChat.rtilCode == this.chatPartyCode) {
        this.rtm.sendChannelMessage(this.message, this.chatPartyCode, {
          enableHistoricalMessaging: true
        });
      } else {
        this.rtm.sendPeerMessage({
          text: this.message,
          sourceMessageId: this.userInfo.rtilCode,
          destinateMessageId: this.activeChat.rtilCode,
          enableHistoricalMessaging: true
        });
      }
      this.recordChatMessage(this.message);
      this.messageInfo[this.activeChat.rtilCode] = this.messageInfo[this.activeChat.rtilCode] || [];
      this.messageInfo[this.activeChat.rtilCode].push({
        source: this.userInfo.rtilCode,
        message: this.message,
        timestamp: new Date().getTime()
      });
      this.dateSplitChatRecord(this.messageInfo[this.activeChat.rtilCode]);
      this.message = '';
      this.$nextTick(() => {
        this.inputMessage('send');
        if (!this.$refs.chat) return;
        const height = this.$refs.chat.scrollHeight;
        $('.chatMessage').animate({
          scrollTop: height
        }, 0);
      });
    },
    receiveMessage({
      action,
      payload
    }) {
      let rtilCode = '';
      if (action == 'ChannelMessage') {
        rtilCode = this.chatPartyCode;
        this.messageInfo[this.chatPartyCode].push({
          source: payload[1],
          message: payload[0].text,
          timestamp: payload[2].serverReceivedTs
        });
        this.dateSplitChatRecord(this.messageInfo[this.chatPartyCode]);
      } else {
        rtilCode = payload[1];
        this.messageInfo[rtilCode] = this.messageInfo[rtilCode] || [];
        this.messageInfo[rtilCode].push({
          source: rtilCode,
          message: payload[0].text,
          timestamp: payload[2].serverReceivedTs
        });
        this.dateSplitChatRecord(this.messageInfo[rtilCode]);
        // 如果有消息过来，则置顶
        this.chatList.forEach((v, index) => {
          if (v.rtilCode == rtilCode) {
            this.chatList.splice(index, 1);
          }
        });
        this.chatList.unshift({
          rtilCode: rtilCode
        });
      }
      let unRead = false;
      if (this.isReadInfo[rtilCode]) {
        if (this.isReadInfo[rtilCode].unRead) {
          // 如果存在未读消息，则发送的消息还是未读状态
          unRead = true;
        } else {
          if (payload[2].serverReceivedTs > this.isReadInfo[rtilCode].time) {
            unRead = true;
          }
        }
      } else {
        // A主动接受B消息，A还没有发送过给B
        unRead = true;
      }
      this.$set(this.isReadInfo, rtilCode, {
        ...this.isReadInfo[rtilCode],
        unRead
      });
    },
    connectionStatus(val) {
      this.rtmStatus = val;
    },
    callBack({
      action,
      payload
    }) {
      switch (action) {
        case 'ChannelMessage':
        case 'PeerMessage':
          this.receiveMessage({
            action,
            payload
          });
          break;
        case 'ConnectionStateChanged':
          this.connectionStatus(payload);
          break;
        case 'REMOTE_LOGIN':
          this.connectionStatus(this.$t('chatM.moreChat'));
          break;
      }
    },
    recordChatTime() {
      // 仅用于记录，更新当前聊天的时间
      const obj = {
        partyCode: this.userInfo.chatCode,
        source: this.userInfo.rtilCode,
        destination: this.activeChat.rtilCode
      };
      if (this.activeChat.rtilCode == this.chatPartyCode) {
        obj.destination = '';
      }
      this.axios.post('/partyline-backend/chat/noLogin/addReadRecord', obj);
      this.$set(this.isReadInfo, this.activeChat.rtilCode, {
        time: new Date().getTime(),
        unRead: false
      });

      // 用于更新上一次选择的人的查看时间
      if (!this.lastActiveRtilCode) return;
      const objLast = {
        partyCode: this.userInfo.chatCode,
        source: this.userInfo.rtilCode,
        destination: this.lastActiveRtilCode
      };
      if (this.lastActiveRtilCode == this.chatPartyCode) {
        objLast.destination = '';
      }
      this.axios.post('/partyline-backend/chat/noLogin/addReadRecord', objLast);
      this.$set(this.isReadInfo, this.lastActiveRtilCode, {
        time: new Date().getTime(),
        unRead: false
      });
    },
    recordChatMessage(message) {
      // 仅用于记录
      const obj = {
        partyCode: this.userInfo.chatCode,
        type: this.chatPartyCode == this.activeChat.rtilCode ? 2 : 1,
        source: this.userInfo.rtilCode,
        destination: this.chatPartyCode == this.activeChat.rtilCode ? '' : this.activeChat.rtilCode,
        message
      };
      this.axios.post('/partyline-backend/chat/noLogin/addRecord', obj);
    },
    compare(protoTypeName) {
      return function (object1, object2) {
        const val1 = object1[protoTypeName];
        const val2 = object2[protoTypeName];
        return val1 - val2;
      };
    },
    inputMessage(str) {
      let height = $('.messageList').height() - $('.sendBox').outerHeight() - 70;
      if (str) {
        height = $('.messageList').height() - 140;
      }
      $('.chatMessage').css({
        'max-height': height
      });
      $('.chatMessage').animate({
        scrollTop: this.$refs.chat.scrollHeight
      }, 0);
    },
    handleKeyCode(event) {
      const e = event || window.event;
      if (!e) return;
      if (event.keyCode == 13) {
        if (!event.shiftKey) {
          event.preventDefault();
          this.sendMessage();
        }
      }
    },
    formatBr(val) {
      return val ? val.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>') : '';
    },
    roleSign(rtilCode, a) {
      if (!this.userInfo.status) return '';
      if (this.userInfo.managerRtils.includes(parseInt(rtilCode))) {
        return 'host';
      } else if (rtilCode == this.userInfo.status.speaker) {
        return 'Speaker';
      } else if (rtilCode == this.userInfo.status.questionSpeaker) {
        return 'Interviewer';
      } else {
        return '';
      }
    },
    changeToLink(txtContent) {
      txtContent ? txtContent.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>') : '';
      if (txtContent) {
        const check_www = 'w{3}' + '[^\\s]*';
        const check_http = '(https|http|ftp|rtsp|mms)://' + '[^\\s]*';
        const strRegex = check_www + '|' + check_http;
        const httpReg = new RegExp(strRegex, 'gi');
        let myHttp = '';
        let frontTextContent = '';
        let backTextContent = '';
        let isOnlyText = false;
        txtContent.replace(httpReg, function (httpText) {
          /*
           如果用户输入的包含了link和文字，将link和文字分开显示
           1. 如果用户输入的文字在链接之前，就显示在链接的前方
           2. 如果用户输入的文字在链接之后，就显示在链接的后方
          */
          if (txtContent.includes(httpText) && httpText) {
            if (txtContent.length > httpText.length) {
              isOnlyText = true;
              if (txtContent.indexOf(httpText) >= 0) {
                frontTextContent = txtContent.substring(0, txtContent.indexOf(httpText));
                backTextContent = txtContent.substring(txtContent.indexOf(httpText) + httpText.length, txtContent.length);
              }
            }
          }
          if (httpText.search('http') < 0 && httpText.search('HTTP') < 0) {
            myHttp = 'http://' + httpText;
            // return '<a href="' + 'http://' + httpText + '" target="_blank">' + httpText + '</a>';
          } else {
            myHttp = httpText;
            // return '<a href="' + httpText + '" target="_blank">' + httpText + '</a>';
          }
        });

        return {
          link: myHttp,
          frontText: frontTextContent || (isOnlyText ? '' : txtContent),
          backText: backTextContent
        };
      }
    },
    myContextmenu(event, value, key) {
      // 获取鼠标的坐标
      const operates = document.querySelectorAll('.contextmenuOperate');
      for (let i = 0; i < operates.length; i++) {
        if (key === i) {
          operates[i].style.display = 'block';
          operates[i].style.left = event.pageX + 'px';
          operates[i].style.top = event.pageY + 'px';
        } else {
          operates[i].style.display = 'none';
        }
      }
    },
    dateSplitChatRecord(messages) {
      /*
       1. 第一条消息前面显示第一消息的产生日期
       2. 从第二条消息起，以后的每一条消息都需要和上一条消息的产生时间进行比较，如果日期不是同一天，则在这个消息的前面显示这个消息的产生日期
      */
      // 第一条消息前面直接显示日期
      if (messages[0]) {
        this.$set(messages[0], 'showDate', true);
      }
      let currentItemTime = '';
      let lastItemTime = '';
      messages.forEach((item, index) => {
        if (index > 0) {
          currentItemTime = Tools.timestampToTime(messages[index].timestamp);
          lastItemTime = Tools.timestampToTime(messages[index - 1].timestamp);
          if (currentItemTime !== lastItemTime) {
            this.$set(messages[index], 'showDate', true);
          } else {
            this.$set(messages[index], 'showDate', false);
          }
        }
      });
    },
    openLink(value) {
      window.open(this.changeToLink(value.message).link, '_blank');
    },
    copyLink(value) {
      return this.changeToLink(value.message).link;
    },
    onCopy() {
      this.$message({
        message: 'Copy successfully',
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: 'Copy failed',
        type: 'error'
      });
    },
    hideLinkOperate(event) {
      if (event.button !== 2) {
        const operates = document.querySelectorAll('.contextmenuOperate');
        for (let i = 0; i < operates.length; i++) {
          operates[i].style.display = 'none';
        }
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.hideLinkOperate, false);
  }
};